export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.7-1015.16",
  commitId: "2f3d4859565e86f76c3edad0e8b440f0ef4a3ab0",
  commitTime: "2026-10-07T10:15:16.000Z",
});
